
function Resume() {
    return (
        <div class="container">
            <div class="row">
                <div class="col-2"></div>
                <div class="col-sm">
                    <h2 class="text-left mt-4">EXPERIENCE </h2>
                    <h6 class="text-muted text-left">SOFTWARE DEVELOPMENT CONSULTANT</h6>
                    <p class="text-left"><b>We-Unit Group S.p.A </b>| April 2023 – Present</p>
                    <ul class="text-left">
                        <li>Developed responsive frontend web pages design using React, Redux, JavaScript, TypeScript, HTML, Bootstrap and Tailwind CSS resulting in around a 15% boost in user engagement.
                        </li>
                        <li>Duties include but are not limited to brainstorming the solutions to a problem with Solution Architect, Integration team Infrastructure team, teams owning upstream systems and other sub teams.
                        </li>
                        <li>Responsible for gathering requirements from Team Lead followed by implementing, migrating to different environments, unit testing, debugging, documenting and supporting the same till production deployment.
                        </li>
                        <li>Successfully worked with cross-functional and diverse teams, fostering interactive and
                            collaborative environments</li>
                        <li> Optimized application performance by implementing Redux, resulting in a 20% decrease in rendering time, enhancing UX
                        </li>
                        <li>Optimized the architecture of existing component in React, resulting in 8% improvement in startup time which impacted the user experience of over 30% customers. </li>
                        <li> Reduced number of API calls from 5 to 1 using lazy loading and improving overall component render performance by 50%</li>
                        <li>Experienced in working with a large code-base with several repositories shared by various teams.
                        </li>{/* <li>Traversy Media</li>
                        <li>Traversy Media</li> */}

                    </ul>
                    <h6 class="text-muted text-left mt-4 pt-4">SOFTWARE ENGINEER</h6>
                    <p class="text-left"><b>Health Sensei </b>| Jan 2021 – April 2023</p>
                    <ul class="text-left">
                        <li>Building the frontend architecture with React to efficiently manage and orchestrate media workflows, while harnessing the capabilities of the MERN stack.
                        </li>
                        <li>Collaborated within an Agile framework, ensuring clear communication and on-time project delivery, contributing to team’s 15% improvement in efficiency.
                        </li>
                        <li>I was a strong advocate for following industry standards and best practices, which helped us create software solutions that were scalable, secure, and dependable and resolved critical PROD issues with high priority on a shorter time frame.</li>
                        <li> Addressed critical product bugs, enhancing product usability by 9% through effective debugging and implementation.
                        </li>
                        <li>Proactively generated comprehensive reports after each version release, strategically utilizing data-driven insights and innovative approaches to continually enhance the application's performance and overall user experience. </li>
                        <li>Experienced in developing end-to-end AEM Components using Java, React, redux, redux-saga, CRXDE Sling Models.
                        </li>
                        <li> <li>Applied strong computer science fundamentals in design, data structures, and problem-solving
                        </li></li>
                        <li>Implemented an Employment Management System, employing MVC design pattern and OOPS concept
                        </li>
                        <li>Demonstrated proficiency with modern front-end build pipelines and tools like Webpack, gulp,
                            and Babel</li>
                        <li>I was a strong advocate for following industry standards and best practices, which helped us create software solutions that were scalable, secure, and dependable. To stay ahead, I constantly explored cutting-edge technologies and frameworks
                        </li>
                        <li>Fostered a collaborative team atmosphere, providing support to colleagues and contributing to a positive work environment. </li>


                    </ul>
                    <h2 class="text-left mt-4">EDUCATION</h2>
                    <h6 class="text-muted text-left">Master of Science</h6>
                    <p class="text-left"><b>Rutgers - The State University Of New Jersey </b>|  2023 –  2024</p>
                    <h6 class="text-muted text-left">BACHELOR OF ENGINEERING</h6>
                    <p class="text-left"><b>Loyola-Icam college of engineering and technology </b>|  2016 –  2020</p>
                    <h6 class="text-left">Topics of interest</h6>
                    <p class="text-left">Software development | Web applications | Data structures and Algorithms</p>

                    <h2 class="text-left mt-4">CERTIFICATIONS</h2>
                    <h6 class="text-muted text-left">React - The Complete Guide (incl. React Router & Redux)</h6>
                    <p class="text-left"><b>Udemy </b>| 2021</p>
                    <h6 class="text-muted text-left">HackerRank Certified CSS</h6>
                    <p class="text-left"><b>HackerRank </b>| 2023</p>
                    <h6 class="text-muted text-left">Cutshot Certified ReactJs - Basics</h6>
                    <p class="text-left"><b>Cutshot </b>| 2023</p>
                    <h6 class="text-muted text-left">Typescript :The New JavaScript for Web Development</h6>
                    <p class="text-left"><b>SkillUp Online </b>| 2023</p>
                    <h6 class="text-muted text-left">Programming in HTML5 with JavaScript and CSS3</h6>
                    <p class="text-left"><b>Great Learning </b>| 2023</p>
                    <h6 class="text-muted text-left">Get started with Figma</h6>
                    <p class="text-left"><b>Coursera </b>| 2023</p>
                    <h6 class="text-muted text-left">Javascript Coding Interview Preparation</h6>
                    <p class="text-left"><b>Simplilearn SkillUp </b>| 2023</p>
                </div>
                <div class="col-2"></div>
            </div>
        </div>
    )
}

export default Resume